import * as C from '../common/constants';
import { useScreenshot } from 'use-react-screenshot';
import { useSelector, useDispatch } from 'react-redux';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useEffect, useState } from 'react';

const useStyles = makeStyles(
  (theme: any): StyleRules =>
    createStyles({
      buttonStyle: {
        padding: '10px 20px',
        border: `1px solid ${COLORS.white}`,
        marginTop: '10px',
        textAlign: 'center',
        '& > span': {
          fontFamily: theme.typography.fontFamily,
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '16px',
          whiteSpace: 'nowrap',
          color: COLORS.white,
        },
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: 0.7,
            transition: '0.5s ease',
          },
        },
      },
      '@media only screen and (max-height: 520px)': {
        buttonStyle: {
          padding: '6px 20px',
          '& > span': {
            fontSize: '12px',
            lineHeight: '12px',
          },
        },
      },
    })
);

const ButtonScreenshot = ({ mainRef }) => {
  const classes = useStyles();

  const appData = useSelector((state: any) => state.app[C.APP_DATA]);
  const labels = appData.labels;

  const currentPaintData = useSelector((state: any) => state.app[C.SET_PAINT]);
  const paintName = currentPaintData?.name || '';

  const [processing, setProcessing] = useState(false);

  const [image, takeScreenshot] = useScreenshot();

  useEffect(() => {
    if (image) {
      const a = document.createElement('a');
      a.href = image;
      a.download = `Tarragon_${paintName}_3D.png`;
      a.click();
    }
  }, [image]);

  useEffect(() => {
    if (processing) {
      takeScreenshot(mainRef.current);
      setProcessing(false);
    }
  }, [processing]);

  const onClick = (event: React.SyntheticEvent) => {
    event.stopPropagation();
    event.preventDefault();

    setProcessing(true);
  };

  if (processing) {
    return null;
  }

  return (
    <div className={classes.buttonStyle} onClick={onClick}>
      <span>{labels?.buttonScreenshotLabel}</span>
    </div>
  );
};

export default ButtonScreenshot;
